let option = window.ELEMENT.Option;

option.props['show'] = {
  type: Boolean,
  default: true
}
option.watch['show'] = {
  handler(v) {
    this.visible = v
  }
}

